<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div class="row my-4">
		<div *ngIf="form.contains('firstName')" class="col-12 col-lg">
			<label for="inputFirstName" class="form-label theme-main-color fw-bold"
				>Prénom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputFirstName"
				name="firstName"
				formControlName="firstName"
				[ngClass]="{
					'is-invalid': firstName.invalid,
					'is-valid': firstName.dirty && firstName.valid
				}"
			/>
			<div
				*ngIf="firstName.invalid && (firstName.dirty || firstName.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="firstName.errors?.required">Un prénom est requis</span>
				<span *ngIf="firstName.errors?.maxlength"
					>Le prénom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="firstName.errors?.pattern"
					>Le prénom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
		<div *ngIf="form.contains('lastName')" class="col-12 col-lg">
			<label for="inputLastName" class="form-label theme-main-color fw-bold"
				>Nom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputLastName"
				name="lastName"
				formControlName="lastName"
				[ngClass]="{
					'is-invalid': lastName.invalid,
					'is-valid': lastName.dirty && lastName.valid
				}"
			/>
			<div
				*ngIf="lastName.invalid && (lastName.dirty || lastName.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="lastName.errors?.required">Un nom est requis</span>
				<span *ngIf="lastName.errors?.maxlength"
					>Le nom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="lastName.errors?.pattern"
					>Le nom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
		<div *ngIf="form.contains('birthdate')" class="col-12 col-lg">
			<label for="inputBirthdate" class="form-label theme-main-color fw-bold"
				>Date de naissance</label
			>
			<input
				autocomplete="off"
				type="text"
				bsDatepicker
				class="form-control"
				id="inputBirthdate"
			/>
		</div>
	</div>

	<div *ngIf="form.contains('address')" class="row my-4">
		<div class="col-12 col-lg">
			<label for="inputAddresse" class="form-label theme-main-color fw-bold"
				>Adresse</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputAddresse"
				name="address"
				[typeahead]="addressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="address"
				(keyup)="selectedAddressKeyUp($event.target)"
				(typeaheadOnSelect)="onAddressSelect($event)"
				[ngClass]="{
					'is-invalid': address.invalid && address.dirty,
					'is-valid': address.valid && address.dirty
				}"
			/>
		</div>
		<div *ngIf="form.contains('tel')" class="col-12 col-lg-4">
			<label for="inputTel" class="form-label theme-main-color fw-bold"
				>Téléphone</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputTel"
				name="tel"
				formControlName="tel"
			/>
		</div>
	</div>

	<div *ngIf="form.contains('email')" class="row my-4">
		<div class="col-12 col-lg-6">
			<label for="inputEmail" class="form-label theme-main-color fw-bold"
				>Email</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputEmail"
				name="email"
				formControlName="email"
			/>
		</div>
		<!--<div class="col-12 col-lg-6">
			<label for="inputEmailConfirm" class="form-label theme-main-color fw-bold"
				>Confirmer l'email</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputEmailConfirm"
				name="emailConfirm"
			/>
		</div>-->
	</div>

	<div class="row my-4">
		<div class="col">
			<label for="inputCenter" class="form-label theme-main-color fw-bold"
				>Centre</label
			>
			<span
				id="inputCenter"
				class="form-control border-0 ps-0"
				[ngClass]="{ 'bg-light': !isAddForm }"
			>
				{{ center?.name }}</span
			>
		</div>

		<div *ngIf="form.contains('area') && isAreaActive" class="col-8 col-8-lg">
			<label for="area" class="form-label theme-main-color fw-bold"
				>Secteur</label
			>
			<select
				class="form-select"
				name="area"
				id="area"
				formControlName="area"
				[ngClass]="{
					'is-invalid': area.invalid,
					'is-valid': area.dirty && area.valid
				}"
				[value]="
					this.beneficiaire?.area
						? this.beneficiaire.area?.name
						: 'Non spécifié'
				"
			>
				<option *ngFor="let area of areaList" value="{{ area?.name }}">
					{{ area?.name }}
					{{ area?.description ? '(' + area?.description + ')' : '' }}
				</option>
			</select>
			<div
				*ngIf="area.invalid && (area.dirty || area.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="area.errors?.required">Un secteur est requis</span>
			</div>
		</div>

		<div class="row my-4">
			<div *ngIf="isSESSAD" class="col-12 col-lg">
				<label for="competence" class="form-label fw-bold">Compétence(s)</label>
				<div class="row">
					<div
						class="col-md-4 check"
						*ngFor="let competence of competences | orderBy : 'name' : 'asc'"
					>
						<input
							type="checkbox"
							name="{{ competence.name }}"
							class="form-check-input"
							[value]="competence"
							[checked]="isCompetenceCheck(competence)"
							[ngClass]="{
								'theme-main-color-check': isCompetenceCheck(competence)
							}"
							(change)="updateSelectedCompetence($event, competence)"
						/>
						<label class="ms-2 form-check-label text-dark">
							{{ getCompetenceLabel(competence) }}
						</label>
					</div>
				</div>
			</div>
		</div>

		<div class="row my-4">
			<div class="col-12 col-8-lg">
				<label for="departments" class="form-label fw-bold">Service(s)</label>
				<div class="row">
					<div
						class="col-md-4 check"
						*ngFor="
							let department of centerDepartments | orderBy : 'name' : 'asc'
						"
					>
						<div>
							<input
								type="checkbox"
								name="{{ department.id }}"
								class="form-check-input"
								[value]="department"
								[checked]="isDepartmentCheck(department)"
								[ngClass]="{
									'theme-main-color-check': isDepartmentCheck(department)
								}"
								(change)="updateSelectedDepartment($event, department)"
							/>
							<label class="ms-2 form-check-label text-dark">
								{{ department.name }}
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row my-4">
			<div *ngIf="isPreferencesActive" class="col">
				<label for="employees" class="form-label theme-main-color fw-bold"
					>{{ LABEL_INTERVENANT | titlecase }}(s) préféré(s)</label
				>
				<input
					autocomplete="off"
					(keyup)="employeeKeyUp($event.target, 'pref', 1)"
					formControlName="preferredEmployee1"
					[typeahead]="listEmployeeMapped"
					typeaheadOptionField="name"
					[typeaheadItemTemplate]="itemTemplateTypeaheadPreferredEmp1"
					[typeaheadMinLength]="0"
					placeholder="{{ LABEL_INTERVENANT | titlecase }}"
					class="form-control"
					[typeaheadScrollable]="true"
					(typeaheadOnSelect)="typeaheadEmployeeOnSelect($event, 'pref', 1)"
					[ngClass]="{
						'is-invalid': form.errors?.employeeRequired
							? true
							: false || !preferredEmployee1?.valid,
						'is-valid':
							preferredEmployee1?.dirty &&
							preferredEmployee1?.valid &&
							!form.errors?.employeeRequired
								? true
								: false
					}"
				/>
				<ng-template
					#itemTemplateTypeaheadPreferredEmp1
					let-model="item"
					let-index="index"
				>
					<span>{{ model?.name }}</span>
				</ng-template>
				<input
					autocomplete="off"
					(keyup)="employeeKeyUp($event.target, 'pref', 2)"
					formControlName="preferredEmployee2"
					[typeahead]="listEmployeeMapped"
					typeaheadOptionField="name"
					[typeaheadItemTemplate]="itemTemplateTypeaheadPreferredEmp2"
					[typeaheadMinLength]="0"
					placeholder="{{ LABEL_INTERVENANT | titlecase }}"
					class="form-control"
					[typeaheadScrollable]="true"
					(typeaheadOnSelect)="typeaheadEmployeeOnSelect($event, 'pref', 2)"
					[ngClass]="{
						'is-invalid': form.errors?.employeeRequired
							? true
							: false || !preferredEmployee2?.valid,
						'is-valid':
							preferredEmployee2.dirty &&
							preferredEmployee2?.valid &&
							!form.errors?.employeeRequired
								? true
								: false
					}"
				/>
				<ng-template
					#itemTemplateTypeaheadPreferredEmp2
					let-model="item"
					let-index="index"
				>
					<span>{{ model?.name }}</span>
				</ng-template>
				<input
					autocomplete="off"
					(keyup)="employeeKeyUp($event.target, 'pref', 3)"
					formControlName="preferredEmployee3"
					[typeahead]="listEmployeeMapped"
					typeaheadOptionField="name"
					[typeaheadItemTemplate]="itemTemplateTypeaheadPreferredEmp3"
					[typeaheadMinLength]="0"
					placeholder="{{ LABEL_INTERVENANT | titlecase }}"
					class="form-control"
					[typeaheadScrollable]="true"
					(typeaheadOnSelect)="typeaheadEmployeeOnSelect($event, 'pref', 3)"
					[ngClass]="{
						'is-invalid': form.errors?.employeeRequired
							? true
							: false || !preferredEmployee3?.valid,
						'is-valid':
							preferredEmployee3?.dirty &&
							preferredEmployee3?.valid &&
							!form.errors?.employeeRequired
								? true
								: false
					}"
				/>
				<ng-template
					#itemTemplateTypeaheadPreferredEmp3
					let-model="item"
					let-index="index"
				>
					<span>{{ model?.name }}</span>
				</ng-template>
			</div>

			<div *ngIf="isPreferencesActive" class="col">
				<label for="employees" class="form-label theme-main-color fw-bold"
					>{{ LABEL_INTERVENANT | titlecase }}(s) incompatible(s)</label
				>
				<input
					autocomplete="off"
					(keyup)="employeeKeyUp($event.target, 'incompat', 1)"
					formControlName="incompatibleEmployee1"
					[typeahead]="listEmployeeMapped"
					typeaheadOptionField="name"
					[typeaheadItemTemplate]="itemTemplateTypeaheadIncompatEmp1"
					[typeaheadMinLength]="0"
					placeholder="{{ LABEL_INTERVENANT | titlecase }}"
					class="form-control"
					[typeaheadScrollable]="true"
					(typeaheadOnSelect)="typeaheadEmployeeOnSelect($event, 'incompat', 1)"
					[ngClass]="{
						'is-invalid': form.errors?.employeeRequired
							? true
							: false || !incompatibleEmployee1?.valid,
						'is-valid':
							incompatibleEmployee1?.dirty &&
							incompatibleEmployee1?.valid &&
							!form.errors?.employeeRequired
								? true
								: false
					}"
				/>
				<ng-template
					#itemTemplateTypeaheadIncompatEmp1
					let-model="item"
					let-index="index"
				>
					<span>{{ model?.name }}</span>
				</ng-template>
				<input
					autocomplete="off"
					(keyup)="employeeKeyUp($event.target, 'incompat', 2)"
					formControlName="incompatibleEmployee2"
					[typeahead]="listEmployeeMapped"
					typeaheadOptionField="name"
					[typeaheadItemTemplate]="itemTemplateTypeaheadIncompatEmp2"
					[typeaheadMinLength]="0"
					placeholder="{{ LABEL_INTERVENANT | titlecase }}"
					class="form-control"
					[typeaheadScrollable]="true"
					(typeaheadOnSelect)="typeaheadEmployeeOnSelect($event, 'incompat', 2)"
					[ngClass]="{
						'is-invalid': form.errors?.employeeRequired
							? true
							: false || !incompatibleEmployee2?.valid,
						'is-valid':
							incompatibleEmployee2.dirty &&
							incompatibleEmployee2?.valid &&
							!form.errors?.employeeRequired
								? true
								: false
					}"
				/>
				<ng-template
					#itemTemplateTypeaheadIncompatEmp2
					let-model="item"
					let-index="index"
				>
					<span>{{ model?.name }}</span>
				</ng-template>
				<input
					autocomplete="off"
					(keyup)="employeeKeyUp($event.target, 'incompat', 3)"
					formControlName="incompatibleEmployee3"
					[typeahead]="listEmployeeMapped"
					typeaheadOptionField="name"
					[typeaheadItemTemplate]="itemTemplateTypeaheadIncompatEmp3"
					[typeaheadMinLength]="0"
					placeholder="{{ LABEL_INTERVENANT | titlecase }}"
					class="form-control"
					[typeaheadScrollable]="true"
					(typeaheadOnSelect)="typeaheadEmployeeOnSelect($event, 'incompat', 3)"
					[ngClass]="{
						'is-invalid': form.errors?.employeeRequired
							? true
							: false || !incompatibleEmployee3?.valid,
						'is-valid':
							incompatibleEmployee3?.dirty &&
							incompatibleEmployee3?.valid &&
							!form.errors?.employeeRequired
								? true
								: false
					}"
				/>
				<ng-template
					#itemTemplateTypeaheadIncompatEmp3
					let-model="item"
					let-index="index"
				>
					<span>{{ model?.name }}</span>
				</ng-template>
			</div>
		</div>
	</div>
	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
